import { useCustom } from '@refinedev/core';

export type SectionOptions = {
  agents: string[];
  domainFilters: string[];
};

export const useSectionOptions = () => {
  const { data, isLoading, isError, error } = useCustom<SectionOptions>({
    url: 'admin/templates/section-options',
    method: 'get',
    queryOptions: {
      staleTime: Infinity,
    },
  });

  return {
    sectionOptions: data?.data as SectionOptions | undefined,
    isLoading,
    isError,
    error,
  };
};
